import { useScrollReveal } from '@/hooks/useScrollReveal';

const jobs = [
  {
    number: '01',
    title: 'スタジオの立ち上げと運営',
    description:
      '高知スタジオの設立から日常業務の統括まで、すべてをリードしていただきます。オフィス環境の整備、業務フローの設計、スタッフが働きやすい場所をゼロから作ってください。',
  },
  {
    number: '02',
    title: 'チームの採用・育成・マネジメント',
    description:
      'AIオペレーター（アニメ制作担当スタッフ）を採用し、一人ひとりの成長を支える環境をつくります。アニメの知識がなくても大丈夫。あなたが育てるチームが、コンテンツを生み出します。',
  },
  {
    number: '03',
    title: '本社・代表との連携',
    description:
      '東京本社および代表の武井と密に連携しながら、制作の進捗や課題を共有します。リモートでも滞りなくコミュニケーションできる体制を一緒に作っていきます。',
  },
  {
    number: '04',
    title: '制作ワークフローの管理',
    description:
      '社内制作支援プラットフォームを活用し、AIを使ったアニメ制作ワークフローを管理します。新しいツールを積極的に取り入れ、チームの生産性を高める役割も担います。',
  },
  {
    number: '05',
    title: '外部パートナーとの調整',
    description:
      '高知県や地元の関連機関、外部パートナーとの折衝・調整を担います。地域と連携しながら事業を育てていく視点が求められます。',
  },
];

export default function JobDescriptionSection() {
  const { ref: headRef, isVisible: headVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="job" className="bg-parchment py-24 md:py-36">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        {/* Section label */}
        <div className="flex items-center gap-4 mb-16">
          <span className="font-sans text-terracotta text-[11px] tracking-[0.4em] uppercase">03</span>
          <div className="flex-1 h-px bg-warm-border" />
          <span className="font-sans text-warm-muted text-[11px] tracking-[0.3em]">Job Description</span>
        </div>

        <div
          ref={headRef}
          className={`mb-16 transition-all duration-900 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="font-serif text-charcoal text-2xl md:text-3xl lg:text-4xl leading-loose">
            担っていただく仕事
          </h2>
          <p className="font-sans text-warm-muted text-sm md:text-base leading-loose mt-4 max-w-2xl">
            スタジオのすべてに関わる、0→1のポジションです。
            決まったことをこなすのではなく、あなた自身が判断し、形にしていく仕事です。
          </p>
        </div>

        <div className="space-y-0">
          {jobs.map((job, i) => (
            <JobItem key={job.number} job={job} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}

function JobItem({
  job,
  delay,
}: {
  job: { number: string; title: string; description: string };
  delay: number;
}) {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <div
      ref={ref}
      className={`group border-t border-warm-border py-8 md:py-10 grid grid-cols-1 md:grid-cols-[80px_1fr] gap-4 md:gap-10 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <span className="font-sans text-terracotta/40 text-4xl font-light leading-none">{job.number}</span>
      <div>
        <h3 className="font-serif text-charcoal text-lg md:text-xl mb-3 group-hover:text-terracotta transition-colors duration-300">
          {job.title}
        </h3>
        <p className="font-sans text-warm-muted text-sm md:text-base leading-loose">{job.description}</p>
      </div>
    </div>
  );
}
